import { toTranslationKey } from '@/utils/stringFormat';
import { maintenanceCategoriesKeys } from '@/consts/MaintenanceCategoriesKeys';
import { MaintenanceMixin } from '@/mixins/Maintenance';
import Loader from '@/components/loader/Loader.vue';
import scheduledMaintenanceDlg
  from "@/views/maintenance/scheduledMaintenance/scheduledMaintenanceDlg/scheduledMaintenanceDlg.vue";
import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";
import {MaintenanceRequestStatus} from "@/enums/MaintenanceRequestStatus";
import {MaintenanceMediaTypes} from "@/enums/MaintenanceMediaTypes";
import moment from "moment";
import ScheduledMaintenanceFormEditDlg
  from '@/views/maintenance/scheduledMaintenance/scheduledMaintenanceFormEditDlg/scheduledMaintenanceFormEditDlg.vue';

export default {
  name: 'scheduledMaintenanceView',
  components: { Loader, scheduledMaintenanceDlg, ScheduledMaintenanceFormEditDlg, ConfirmDlg },
  mixins: [MaintenanceMixin],
  data() {
    return {
      loading: true,
      deleteLoading: false,
      additionalResponse: '',
      selectedTechnician: null,
      headers: [
        {
          text: 'Status',
          align: 'start',
          value: 'status',
        },
        {
          text: 'Creation Date',
          align: 'start',
          value: 'dateTimeD',
        },
        {
          text: 'Due Date',
          align: 'start',
          value: 'estimatedCompletionDate',
        },
        {
          text: 'Completion Date',
          align: 'start',
          value: 'completionDateD',
        },
        {
          text: 'Assigned To',
          align: 'start',
          value: 'assignee',
        },

        // {
        //   text: this.$i18n.messages[this.$i18n.locale][
        //     'MaintenanceList.RequestAge'
        //   ],
        //   align: 'start',
        //   value: 'requestAge',
        // },
      ],
      headersForms: [
        {
          text: 'Form name',
          align: 'start',
          value: 'name',
        },
        {
          text: 'Location',
          align: 'start',
          value: 'locationId',
        },
        {
          text: '',
          align: 'end',
          value: 'status',
          sortable: false,
        },
      ],
      ticketPriority: null,
      ticketPriorityOptions: ['Low', 'Medium', 'High', 'Urgent'],
      estimatedDeliveryDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
    };
  },
  computed: {
    request() {
      return this.$store.state.maintenanceModule.currentSchedMaint;
    },
    maintenanceScheduledForms() {
      return this.request?.forms || [];
    },
    maintenanceRequests() {
      const maintenanceRequests = this.$store.state.maintenanceModule.currentSchedMaintList;

      maintenanceRequests.forEach((request) => {
        const isHour = request.requestAge >= 60;
        const value = isHour ? Number((request.requestAge / 60).toFixed(0)) : request.requestAge.toFixed(0);
        request.hoursAgo = `${value} ${isHour ? this.$t(`GeneralTranslations.Hour${value > 1 ? 's' : ''}`) : this.$t(`GeneralTranslations.Minute${value > 1 ? 's' : ''}`)}`;
      });

      return maintenanceRequests;
    },
    maintenanceFormsScheduledJob() {
      return this.$store.state.maintenanceModule.maintenanceFormsScheduledJob;
    },
    maintenanceTemplates() {
      return this.$store.state.maintenanceModule.maintenanceTemplates;
    },
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    MaintenanceTechnicians() {
      return [...this.$store.state.userModule.maintenanceUsers, ...this.$store.state.userModule.maintenanceVendors.map(x => { return {...x, isVendor: true} })];
    },
    MaintenanceMediaTypes() {
      return MaintenanceMediaTypes;
    },
    jsonFields() {
      const jsonFields = {
        "Field": "title"
      };

      this.maintenanceRequests.forEach((request, index) => {
        jsonFields[`Request${index + 1}`] = `value${index + 1}`;
      })

      return jsonFields;
    },
    requests() {
      const fields = [
        { title: "Maintenance job", getValue: r => r.name },
        { title: "Category", getValue: r => r.category },
        { title: "Status", getValue: r => this.getStatus(r.status) },
        { title: "Scheduled work order", getValue: r => r.customId },
        { title: "Request date", getValue: r => this.formatDate(r.dateTime) },
        { title: "Work order date", getValue: r => this.formatDate(r.assignedDate) },
        { title: "Due Date", getValue: r => this.formatDate(r.estimatedCompletionDate, false) },
        { title: "Completed date", getValue: r => this.formatDate(r.completedDateTime) },
        { title: "Days taken", getValue: r => r.openDuration },
        { title: "Request age", getValue: r => r.hoursAgo },
        { title: "Description", getValue: r => r.description },
        { title: "Room Name", getValue: r => r.roomName },
        { title: "Location", getValue: r => r.location },
        { title: "Vendor Assigned", getValue: r => r.assignee ? 'Yes' : 'No' },
        { title: "Vendor Name", getValue: r => r.assignee },
        { title: "Vendor Contact Email", getValue: r => r.assigneeEmail },
        { title: "Vendor Contact Number", getValue: r => r.assigneePhoneNumber },
        { title: "Risk", getValue: r => r.risk ? r.risk.charAt(0).toUpperCase() + r.risk.slice(1) : '' },
        { title: "Risk Text", getValue: r => r.riskText },
        { title: "Priority", getValue: r => r.priority },
        { title: "Type", getValue: r => r.maintenanceType ? r.maintenanceType.charAt(0).toUpperCase() + r.maintenanceType.slice(1) : '' }
      ];

      const array = fields.map(f => ({ title: f.title }));

      this.maintenanceRequests.forEach((request, index) => {
        fields.forEach((f, i) => {
          array[i][`value${index + 1}`] = f.getValue(request);
        });
      });

      return array;
    }
  },
  async created() {
    await this.$store.dispatch('getScheduledMaintenanceById', this.$route.params.id);
    await this.$store.dispatch('getRequestsByScheduledMaintenanceId', this.$route.params.id);
    await this.$store.dispatch('getMaintenanceFormsByScheduledMaintenanceId', this.$route.params.id)
    await this.$store.dispatch('getMaintenanceUsers');
    await this.$store.dispatch("getMaintenanceVendors");
    await this.$store.dispatch('getVendors');
    await this.$store.dispatch('getMaintenanceCategories');
    await this.$store.dispatch("getMaintenanceTemplates");
    await this.$store.dispatch("getMaintenanceTypes");

    this.loading = false;
  },
  methods: {
    convertToTranslationKey(text) {
      return toTranslationKey(text);
    },
    routeToRequestList() {
      this.$router.push('/scheduledMaintenance');
    },
    updateScheduledMaintenance() {
      this.$refs.scheduledMaintenanceDlg.open('update', this.request);
    },
    closeEditPopup() {
      this.$forceUpdate();
    },
    deleteScheduledMaintenance() {
      this.$refs.confirmDlg.open(null, this.$t("MaintenanceSchedule.MaintenanceScheduleDeleteMessage"), false).then(async response => {
        if (response && response.agree) {
          this.deleteLoading = true;

          await this.$store.dispatch("deleteScheduledMaintenance", this.request.id);

          this.$toast.open({
            type: "success",
            message: this.$t("MaintenanceSchedule.MaintenanceScheduleDeleteSuccess")
          });

          this.deleteLoading = false;

          this.$router.push({ path: "/scheduledMaintenance" })
        }
      })
    },
    handleClickRequest(row): void {
      this.$router.push({ path: `/maintenanceRequests/${row.id}` });
    },
    getStatus(status) {
      switch (status) {
        case MaintenanceRequestStatus.New: {
          return this.$t("MaintenanceList.New");
        }
        case MaintenanceRequestStatus.InProgress: {
          return this.$t("MaintenanceList.InProgress");
        }
        case MaintenanceRequestStatus.Cancelled: {
          return this.$t("MaintenanceList.Cancelled");
        }
        case MaintenanceRequestStatus.Complete: {
          return this.$t("MaintenanceList.Completed");
        }
      }
    },
    isCompletedRequest(item) {
      if(
        (item.status === MaintenanceRequestStatus.Complete && item.completionDateD) ||
        (item.status === MaintenanceRequestStatus.Cancelled) ||
        ([MaintenanceRequestStatus.InProgress, MaintenanceRequestStatus.New].includes(item.status) && moment().format('YYYY-MM-DD') <= moment(item.estimatedCompletionDate).format('YYYY-MM-DD'))
      ) {
        return true;
      }

      return false;
    },
    editForm(form, status: string) {
      form.template = this.maintenanceTemplates.find(x => x.id === form.templateId)?.template;
      this.$refs.scheduledMaintenanceFormEditDlg.open(form, status);
    },
    getForms(request) {
      const forms = request?.forms;
      const array = [];

      if(forms && forms?.length) {
        for(let i = 0; i < forms?.length; i++) {
          const form = this.maintenanceFormsScheduledJob.find(x => x.id === forms[i].formId);
          if(!form) return;

          array.push({
            title: "Form ID",
            value: form.id,
          });

          array.push({
            title: "Form Name",
            value: form?.name,
          });

          if(form.result) {
            const keys = [];
            JSON.parse(form.template).pages.forEach((page) => {
              page.elements.map((element) => {
                keys.push(element.name);
              })
            });

            let index = 1;
            for (const key of keys) {
              const value = form.result[key];

              array.push({
                title: `Form Question ${index}`,
                value: key,
              });

              array.push({
                title: `Form Question ${index} Answer`,
                value: this.getQuestionValue(value),
              });

              index++;
            }
          }
        }

        return array;
      }
    },
    getQuestionValue(value) {
      if(typeof value === 'string') {
        if(value.includes("base64")) {
          return "True"
        }

        return value ? value : "-";
      }

      if(typeof value === 'object') {
        if(value?.type && ["image/jpeg", "image/jpg", "image/png", "image/webp"].includes(value.type)) {
          return value.content ? "True" : "False";
        }

        if(Array.isArray(value)) {
          if(value.length) {
            return value.join(", ");
          } else {
            return "-";
          }
        }

        return "-"
      }

      if(typeof value === 'boolean') {
        return value ? "True" : "False";
      }

      if(!value) {
        return "-";
      }

      return value;
    },
    formatDate(timestamp, isSeconds = true) {
      if (!timestamp) return null;
      const ms = isSeconds ? timestamp.seconds * 1000 : timestamp;
      return moment(ms).format("DD MMM YYYY, HH:mm A");
    }
  },
};